<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
    >
        <el-form
                :model="dataForm"
                ref="dataForm"
                :rules="dataRule"
                @keyup.enter.native="dataFormSubmit()"
                label-width="132px"
                style="display: flex;flex-wrap: wrap;justify-content: space-between"
        >
            <el-form-item label="字段名称：" prop="columnName">
                <el-input v-model="dataForm.columnName" placeholder="字段名称"></el-input>
            </el-form-item>
            <el-form-item label="显示名称：" prop="displayName">
                <el-input v-model="dataForm.displayName" placeholder="字段编码"></el-input>
            </el-form-item>
            <el-form-item label="字段类型：" prop="columnType">
                <el-select
                        v-model="dataForm.columnType"
                        placeholder="字段类型"
                        style="display: block; margin-bottom: 10px"
                >
                    <el-option
                            v-for="item in columnTypeList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否展示：" prop="showInList">
                <el-select v-model="dataForm.showInList" placeholder="是否展示"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否展示显示名：" prop="textType">
                <el-select v-model="dataForm.textType" placeholder="是否展示显示名"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions2"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否为查询参数：" prop="isQueryParam">
              <el-select v-model="dataForm.isQueryParam" placeholder="是否为查询参数"
                         style="display: block;margin-bottom: 10px">
                <el-option
                    v-for="item in trueOrFalseOptions3"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="脱敏类型：" prop="desensitType">
                <el-select
                        v-model="dataForm.desensitType"
                        placeholder="脱敏类型"
                        clearable
                        style="display: block; margin-bottom: 10px">
                    <el-option
                            v-for="item in desensitTypeList"
                            :key="item.type"
                            :label="item.name"
                            :value="item.type"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="拼接前缀：">
                <el-input v-model="dataForm.prefix" placeholder="拼接前缀"></el-input>
            </el-form-item>
            <el-form-item label="拼接后缀：">
                <el-input v-model="dataForm.suffix" placeholder="拼接后缀"></el-input>
            </el-form-item>
            <el-form-item label="控制长度：" prop="showLength">
                <el-input v-model="dataForm.showLength" placeholder="显示名长度"></el-input>
            </el-form-item>

            <el-form-item label="是否必填：" prop="required">
                <el-select v-model="dataForm.required" placeholder="是否隐藏"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in trueOrFalseOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="单（多）选类型：" prop="singleRadio">
                <el-select v-model="dataForm.singleRadio" placeholder="单（多）选类型"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in radioOrCheckOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="数据源类型：" prop="datasetType">
                <el-select
                        v-model="dataForm.datasourceType"
                        placeholder="数据源类型"
                        style="display: block; margin-bottom: 10px"
                >
                    <el-option
                            v-for="item in datasourceTypeList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item><el-form-item label="数据源类型：" prop="datasetType">
                <el-select
                        v-model="dataForm.datasourceType"
                        placeholder="数据源类型"
                        style="display: block; margin-bottom: 10px"
                >
                    <el-option
                            v-for="item in datasourceTypeList"
                            :key="item.id"
                            :label="item.text"
                            :value="item.id"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间格式：" >
                <el-input v-model="dataForm.patternRegex" placeholder="请输入时间格式"></el-input>
            </el-form-item>

          <el-form-item label="数据源：" prop="datasource">
                <el-input v-model="dataForm.datasource" placeholder="数据源"></el-input>
            </el-form-item>
            <br>
            <el-form-item label="列数：" prop="columnCount">
                <el-select v-model="dataForm.columnCount" placeholder="列数"
                           style="display: block;margin-bottom: 10px">
                    <el-option
                            v-for="item in columnCountOptions"
                            :key="item.value"
                            :label="item.text"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="列宽：" prop="columnWidth">
                <el-input
                        v-model="dataForm.columnWidth"
                        placeholder="排序"
                ></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="sort">
                <el-input
                        v-model="dataForm.sort"
                        placeholder="排序"
                ></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import axios from "axios";

    const defaultForm = {
        id: "",
        formId: "",
        desensitType:'',
        columnName:"",
        textType:1,
        displayName:"",
        columnType:'2',
        showInList:true,
        required:"",
        datasource:"",
        datasourceType:"",
        patternRegex:"",
        columnCount:'2',
        columnWidth:"",
        showLength:'50',
        prefix:"",
        suffix:"",
        singleRadio:"",
        isQueryParam:"",
        sort: 10
    }
    export default {
        props: ["mainContentViewHeight"],
        data() {
            return {
                visible: false,
                datasourceTypeList: [],
                columnTypeList:[],
                desensitTypeList:[],
                dictCateList: [],
                dataForm: defaultForm,
                columnCountOptions: [{'text': '单列(整行)', 'value': '1'}, {'text': '两列', 'value': '2'}, {'text': '三列', 'value':'3'}],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                trueOrFalseOptions2: [{'text': '否', 'value': 0}, {'text': '是', 'value': 1}],
                trueOrFalseOptions3: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                radioOrCheckOptions: [{'text': '单选', 'value': '1'}, {'text': '多选', 'value': '2'}],
                dataRule: {
                    columnName: [
                        {required: true, message: '字段名不能为空', trigger: 'blur'},
                    ],
                    showInList: [
                        {required: true, message: '是否展示不能为空', trigger: 'blur'},
                    ],
                    displayName: [
                        {required: true, message: '显示名不能为空', trigger: 'blur'},
                    ],

                }
            };
        },
        created() {
            this.initSelectData();
            this.getDicData();
            this.getDic('form_input_type');
        },
        methods: {
            init(id,fromId, groupId) {
                this.dataForm.id = id || "";
                this.dataForm.formId = fromId || "";
                this.dataForm.groupId = groupId || '';
                this.visible = true;
                if (this.dataForm.id) {
                    this.$http({
                        url: this.$http.adornUrl("/customform/fromdatasetfield/get?id=" + this.dataForm.id),
                        method: "get",
                        baseURL: '',
                    }).then(({data}) => {
                        if (data && data.code === "1") {
                            this.dataForm = {...data.data};
                            this.dataForm.columnType = data.data.columnType;
                            this.dataForm.showLength = data.data.showLength?data.data.showLength:'50';
                            this.dataForm.columnCount = data.data.columnCount?data.data.columnCount:'1';
                            this.dataForm.singleRadio = data.data.singleRadio?data.data.singleRadio:'1';
                            this.dataForm.desensitType = data.data.desensitType == 0?'':data.data.desensitType
                        } else {
                            this.dataForm = defaultForm;
                        }
                    });
                }
            },
            getDicData(){
                this.$http({
                    url: this.$http.adornUrl('/customform/fromdatasetfield/getDesensitizatType'),
                    method: "get",
                    baseURL: '',
                }).then(res => {
                    if (res.data.code === '1') {
                        this.desensitTypeList = res.data.data
                    }else{
                        this.desensitTypeList = [];
                    }
                })

            },
            getDic(type) { // 获取字典
                this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
                    if (res.data.code === '1') {
                        switch (type) {
                            case 'form_input_type':this.columnTypeList = res.data.data;break;
                        }
                    }
                })
            },
            getHttpReq(url, method = "post", extOps) {
                let ops = {
                    url: url,
                    method: method,
                    baseURL: '',
                };
                ops = Object.assign(ops, extOps);
                return this.$http(ops);
            },
            transformToInt(data) {
                let tmp = []
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    element.id = parseInt(element.id)
                    if (isNaN(element.id)) {
                        element.id = 0
                    }
                    tmp.push(element)
                }
                return tmp
            },
            initSelectData() {
                let _self = this;
                axios
                    .all([
                        this.getHttpReq(this.$http.adornUrl("/customform/getEnumList/0?required=true"), "get"),
                        //         this.getHttpReq("/sys/dict/getDictCategoryList2", "get"),
                    ])
                    .then(
                        axios.spread(function (datasourceTypes, dictCataegory) {
                            let tmp = datasourceTypes.data
                            let result = []
                            for (var i = 0; i < tmp.length; i++) {
                                let item = tmp[i];
                                if (item.id == 4 || item.id == 5 || item.id == 6) {
                                    continue
                                }
                                result.push(item)
                            }
                            _self.datasourceTypeList = _self.transformToInt(result);
                            _self.dictCateList = (dictCataegory && dictCataegory.data) || [];
                        })
                    );
            },
            // 表单提交
            dataFormSubmit() {
                if (this.dataForm.formId == undefined) {
                    this.$message.error('自定义表单无效');
                    return;
                }
                this.$http({
                    url: this.$http.adornUrl("/customform/fromdatasetfield/save"),
                    method: "post",
                    baseURL: '',
                    data: this.dataForm,
                }).then(({data}) => {
                    if (data && data.code === "1") {
                        this.$message({
                            message: "操作成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                this.visible = false;
                                this.$emit("refreshDataList");
                            },
                        });
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .el-form /deep/ .el-form-item {
        width: 50%;
    }

    .el-dialog__wrapper /deep/ .el-dialog__footer {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
